import type { MatchColumnsProps, MatchedOptions } from '../Steps/MatchColumns'

export const uniqueEntries = <T extends string>(
  data: MatchColumnsProps<T>['data'],
  index: number
): Partial<MatchedOptions<T>>[] => {
  return Object.values(data.map(row => ({ entry: row[index] })).filter(item => item.entry != null && `${item.entry}`.trim() !== '').reduce((map, item) => ({ ...map, [`${item.entry}`]: item }), {}));
}
